import { Component, ViewEncapsulation, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { AccountService, EventManager } from 'src/app/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from './modules/users/users.service';
import { AppQueries, Dispatcher, GetAllResource, GetCRMStatus, StoreUserProfile } from './state';
import { environment } from 'src/environments/environment';
import { ViewImageComponent } from './shared/components/view-image/view-image';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ThemeService } from './shared/services/theme.service';
declare var $;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [TranslateService]
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  title = 'admin-fmarket';
  spinner: number = 0;
  transactions: any[] =[];
  totalTransactions: any;
  totalSupport: any;
  myInterval: any;
  ignoreApi: any[] = [];
  theme: string = 'default';
  isShowSpinner = false;
  currentUrl: string = '';
  constructor(
    private translate: TranslateService,
    private dispatcher: Dispatcher,
    private router: Router,
    private route: ActivatedRoute,
    private spinnerService: NgxSpinnerService,
    private sessionStorageService: SessionStorageService,
    private localStorage: LocalStorageService,
    private accountService: AccountService,
    public toast: ToastrService,
    public notificationService: NotificationService,
    private appQueries: AppQueries,
    public modalService: NzModalService,
    private themeService: ThemeService,
    private eventManager: EventManager) {
      translate.addLangs(['en_US', 'vi_VN']);
      // this language will be used as a fallback when a translation isn't found in the current language
      translate.setDefaultLang('vi_VN');
      // the lang to use, if the lang isn't available, it will use the current loader to get them
      translate.use('vi_VN');
    }
  ngOnInit() {
    this.changeTheme('primary');
    const token = this.localStorage.retrieve(environment.KEY_TOKEN)
      || this.sessionStorageService.retrieve(environment.KEY_TOKEN);
    if (token) {
      this.dispatcher.fire(new GetAllResource());
      const userProfile = this.sessionStorageService.retrieve('USER_PROFILE');
      this.accountService.authenticate(userProfile);
      this.dispatcher.fire(new StoreUserProfile(userProfile));
    } else {
      this.appQueries.userProfile$
      .subscribe((userProfile) => {
        if (userProfile) {
          this.dispatcher.fire(new GetAllResource());
        }
      });
    }
    this.initIgnorepis();
    this.eventManager.subscribe('show-spinner', (res) => {
      this.isShowSpinner = true;
    });
    this.eventManager.subscribe('close-spinner', (res) => {
      this.isShowSpinner = false;
    });
    this.eventManager.subscribe('show-image', (res) => {
      this.showImage(res.content.image);
    });
    this.eventManager.subscribe('change-theme' , (res) => {
      this.changeTheme(res.content.theme);
    });
    this.eventManager.subscribe('Fmarket.authenError' , (content) => {
      this.eventManager.broadcast({name: 'close-spinner'});
      this.router.navigate(['/authentication/login']);
    });
    this.eventManager.subscribe('Fmarket.httpError' , (content) => {
      this.eventManager.broadcast({name: 'close-spinner'});
      if (!this.ignoreError(content.content.url || '')) {
        this.toast.error(content.content.error.message || content.content.error.status || 'Đang có lỗi xảy ra!');
      }
    });
    this.eventManager.subscribe('login-success' , (content) => {
    });
    this.eventManager.subscribe('update-params-router' , (res) => {
      const urlNoQueryParams = this.currentUrl.split('?')[0];
      this.router.navigate([urlNoQueryParams], {queryParams: res.content});
    });
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log(event);  
        this.currentUrl = event.url;
      }
    });
    
    setInterval(() => {
      this.autoCallAPIPendingSession();
    }, 60 * 1000 * 10)
  }
  ngAfterViewInit() {
    $('body').on('click', (e) => {
      this.eventManager.broadcast({
        name: 'body-click',
        content: {
          event: e
        }
      })
    });
  }
  ngOnDestroy() {
    clearInterval(this.myInterval);
  }
  autoCallAPIPendingSession() {
    this.accountService.autoCallAPIPendingSession()
    .subscribe(() => {
      // Holding Session Token
    })
  }
  initIgnorepis() {
    this.ignoreApi = [
      'downloadContract'
    ];
  }
  ignoreError(url) {
    return this.ignoreApi.some((api) => url.includes(api));
  }
  showImage(image) {
    const modal = this.modalService.create({
      nzTitle: '',
      nzWidth: '1100px',
      nzStyle: {top: '20px'},
      nzContent: ViewImageComponent,
      nzData: {
        image
      },
      nzOnOk: (() => { })
    });
  }
  changeTheme(theme) {
    theme = theme || 'default';
    this.theme = theme;
    this.localStorage.store('theme', theme);
    this.themeService.changeTheme(theme);
  }
}
